import { render, staticRenderFns } from "./Jmanual.vue?vue&type=template&id=32ad7d86&scoped=true"
import script from "./Jmanual.vue?vue&type=script&lang=js"
export * from "./Jmanual.vue?vue&type=script&lang=js"
import style0 from "./Jmanual.vue?vue&type=style&index=0&id=32ad7d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad7d86",
  null
  
)

export default component.exports